import {vignettePicker_template} from "../components/templates/vignettePicker_template";
import {vignettePicker_helper} from "./vignettePicker_helper";

/**
 * Uses the standard vignette picker form, but writes its configured result to
 * the sidebar widget model instead of inserting an article display card.
 */
export class configSidebar_vignettePicker_helper extends vignettePicker_helper {
    private readonly onSelect: (vignette: any) => void;

    constructor(vignettePicker: vignettePicker_template, vnAppZone: any, callerModule: any, onSelect: (vignette: any) => void) {
        super(vignettePicker, vnAppZone, callerModule);
        this.onSelect = onSelect;
    }

    protected insertVignetteDisplayCardElement(_elementToReplace: any, vignetteObject: any) {
        this.onSelect(vignetteObject);
        this.vignettePicker.vignettePickerInsertForm_template.hide();
        this.vignettePicker.hide();
    }
}



// WEBPACK FOOTER //
// ./js/modules/configSidebar_vignettePicker_helper.ts